import React, { Fragment, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import OtpInput from 'react-otp-input'
import { Button } from 'loyal-react'
import { Link } from 'react-router-dom'

import '@loyal_template/password.css'

const ConfirmTokenBox = ({
  token,
  isLoading,
  maskedEmail,
  onChangeToken,
  isValid,
  toSeconds,
  expiredTime,
  timeLeft,
  isLoadingToken,
  disableVerifyInput,
  sendTokenAgain,
  confirmToken
}) => {
  const changeToken = e => {
    onChangeToken(e)
  }

  const passwordContainerRef = useRef()

  useEffect(() => {
    const inputs = passwordContainerRef.current.querySelectorAll('input')
    inputs.forEach((input, index) => {
      input.setAttribute('aria-label', `${index + 1}º digito`)
    })
  }, [])

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 border-color-ui-3 bg-white border radius'>
          <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
            <section className='col mr-auto'>
              <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                verifique seu e-mail
              </h1>
            </section>
          </div>
          <div className='col-12 border-color-ui-3'>
            <p className='my-2'>
              para sua segurança, enviamos um código para o seu e-mail:
            </p>
            <h2
              className='h3 txt-title-3 col-12 col-md-6 color-brand-1 txt-font-body mb-1 border border-color-brand-1 p-2'
            >
              {maskedEmail}
            </h2>
            <Link
              to='/security-access'
              className='color-brand-1 d-none'
              title='Vai para tela de alterar email'
            >
              Oops! Este não é o meu e-mail
            </Link>
            <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
            <p className='my-2'>
              agora digite o código de verificação nos campos abaixo.
            </p>
            <div
              ref={passwordContainerRef}
              className='col-12 password-numeric-box pos-relative t-1'
              aria-label='Campos de senha numérica'
            >
              <OtpInput
                value={token}
                onChange={changeToken}
                shouldAutoFocus
                numInputs={6}
                focusStyle={{ outline: 0 }}
              />
            </div>
            <div className='col-12 col-md-6 mt-2' />
            <div className='col-12 col-md-6 mt-2'>
              <div className='col-12 px-0 pb-2'>
                <Button
                  id={'btn-confirmToken'}
                  name={'btn-confirmToken'}
                  className='btn-sm btn-featured btn-continuar-sg border btn-heigth-pros border-color-ui-3 mr-1 height50'
                  type='button'
                  text='confirmar e finalizar'
                  disabled={!isValid}
                  onClick={confirmToken}
                  loading={isLoading}
                />
              </div>
              <div className='col-12 px-0 pb-2'>
                <Button
                  id={'btn-resend'}
                  name={'btn-resend'}
                  className='btn-heigth-pros btn-especific btn-reenviar mr-1 height50'
                  type='button'
                  text={expiredTime ? 'Reenviar' : `Reenviar em ${toSeconds(timeLeft)}`}
                  onClick={sendTokenAgain}
                  loading={isLoadingToken}
                  disabled={!expiredTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

ConfirmTokenBox.propTypes = {
  onChangeToken: PropTypes.func.isRequired,
  toSeconds: PropTypes.func.isRequired,
  sendTokenAgain: PropTypes.func.isRequired,
  confirmToken: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  maskedEmail: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
  disableVerifyInput: PropTypes.bool,
  expiredTime: PropTypes.bool,
  timeLeft: PropTypes.number,
  isLoadingToken: PropTypes.bool,
  isLoading: PropTypes.bool
}

export default ConfirmTokenBox



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/ChangeUraPassword/ConfirmTokenBox/ConfirmTokenBox.js